import { take, call } from 'redux-saga/effects';
import { LanguageLoadFailureAction } from 'actions/appActions';
import { delay } from 'redux-saga/effects';

export function* languageLoadFailureWatcher() {
    while (true) {
        const action: LanguageLoadFailureAction = yield take('LANGUAGE_LOAD_FAILURE');
        const { languageCode } = action.meta;

        // Wait one second and redirect to force English
        if (languageCode !== 'en') {
            yield delay(1000);
            yield call([ window.location, 'replace' ], '/Client?lang=en');
        }
    }
}


// WEBPACK FOOTER //
// ./src/sagas/app/languageFailureRecoverySaga.ts